import { t as globalT } from "@lingui/core/macro";
import { createFileRoute } from "@tanstack/react-router";

import ChooseProject from "@/components/ChooseProject.tsx";

export const Route = createFileRoute(
  "/flows/authorize-external/choose-project",
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title:
          globalT`Sweco REALity` +
          " - " +
          globalT`Authorize` +
          " - " +
          globalT`Choose project`,
      },
    ],
  }),
});

function RouteComponent() {
  return (
    <ChooseProject link="/flows/authorize-external/authorize/$identifier" />
  );
}
